export const statusList = [
  { label: "Todos", value: "" },
  { label: "Aberto", value: "ABERTO" },
  { label: "Em Andamento", value: "EM ANDAMENTO" },
  { label: "Conciliado", value: "CONCILIADO" },
];

export const modeList = [
  { label: "OFX", value: "OFX" },
  { label: "Open Finance", value: "OPEN_FINANCE" },
];

export const dateFromList = [
  { label: "Extrato", value: "extrato" },
  { label: "Importação", value: "importacao" },
  { label: "Conciliação", value: "conciliacao" },
];

export const mismatchTypeActions = {
  fineFees: { label: "Aplicar Juros / Multa" },
  credit: { label: "Lançar Crédito" },
  ignore: { label: "Ignorar" },
  rebate: { label: "Aplicar Abatimento" },
  partiallySettled: { label: "Liquidação Parcial" },
};

export const codigoJurosMora = {
  day: { value: "1" },
  month: { value: "2" },
  none: { value: "3" },
};

export const fineFessDescription = {
  1: "Valor por dia",
  2: "Taxa mensal",
  3: "Isento",
};
